import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import { Button } from 'reactstrap';
import ServicesList from './ServicesList';
import ServicesListActions from './ServicesListActions';

const ModalServicesList = ({ closeModal, opened, preAddItemService }) => {

    const [services,setServices] = useState([]);

    useEffect(() => {
        listServices();
    }, []);

    const listServices = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'servicio/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(data => {
            setServices(data);
        }).catch((error) => {
            console.error('Error:', error);
            setServices([]);
        });
    }

    const handleCloseModal = () => {
        closeModal();
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Lista de Servicios</h5>
                        </div>
                    </div>

                    <ServicesList reactTableData={services} ReactTableActions={ServicesListActions} preAddItemService={preAddItemService} />

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                handleCloseModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default ModalServicesList;
